// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_9l-4";
export var collapsed = "_9l-1";
export var headerBar = "_9l-0";
export var leftHeaderContent = "_9l-3";
export var subjectContainer = "_9l-2";